export default __webpack_public_path__ + "static/media/efficentDevImage.2faf6e0b.jpg";